// fetchMeBalance.js
'use strict';

import mergeMeData from '../action/mergeMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch me balance
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchMeBalance = () => async (dispatch, getState) => {
  const networkingSelectPath = ['fetch', 'balance'];
  const token = getMeData(getState(), 'token');
  const isFetching = getNetworkingData(
    getState(),
    networkingSelectPath,
    'isFetching'
  );
  if (!token || isFetching) return dispatch({ type: '' });
  const fetchOptions = {
    method: 'GET',
    headers: {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    },
  };
  const fetchUrl = getResourceUrl({ endpoint: '/me/balance' });
  dispatch({
    type: SET_NETWORKING_FETCHING,
    payload: { selectPath: networkingSelectPath },
  });
  try {
    let response = await fetch(fetchUrl.href, fetchOptions);
    if (!response.ok) {
      response = await handleFetchError({
        response,
        dispatch,
        getState,
        fetchOptions,
        fetchUrl,
      });
    }
    const payload = (await response.json()) || {};
    dispatch(
      mergeMeData({
        field: 'balance',
        value: {
          total: payload.balance,
        },
      })
    );
    return dispatch({
      type: SET_NETWORKING_SUCCESS,
      payload: { selectPath: networkingSelectPath },
    });
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath: networkingSelectPath, error },
    });
  }
};

export default fetchMeBalance;
